import { Redirect } from "expo-router";
import { CENTRAL_APP_URL } from "../../../../src/lib/hosting-contract";

export default function LegacyDirectorRoute() {
  return <Redirect href={CENTRAL_APP_URL} />;
}
